export default __webpack_public_path__ + "static/media/beVELO.469d55b1.svg";